import {customLog} from "./customLog.js";
export function inlineDataIntoCompositions(comps, users, tags, contexts, includedComps)
{
  return comps.map((comp)=>inlineDataIntoComposition(comp, users, tags, contexts, includedComps));
}

export function inlineDataIntoComposition(comp, users, tags, contexts, includedComps)
{
  const userFound = !users || users.length == 0 ? null : users.find((u)=>u.user_id == comp.user_id);

  const userName = userFound ? userFound.name : "id: " + comp.user_id;
  
  return Object.assign({}, comp,
        {
          included:includedComps && includedComps.indexOf(comp.composition_id) != -1,
          tagNames:comp.tags.map((tC)=>{ const tag = !tags ? "#"+{tC} + " " : tags.find((t)=>t.tag_id == tC); return tag ? "#" + tag.name : "";}),
          user: userName,
          context: !contexts || contexts.length == 0 ? comp.context_id.toString() : contexts.find((c)=>c.context_id == comp.context_id).name,
        });  
}

export function getlongitudeLatitudeFromLongLat(longLat)
{ return {longitude: longLat.lng, latitude: longLat.lat};}



export function transformCompositionsFromDb(compsFromDb)
{
	return compsFromDb.map((comp)=>{return transformCompositionFromDb(comp)});
}

export function transformCompositionFromDb(objFromDb)
{
  if(!objFromDb)
    customLog("transforming null composition:");
  
  const reassignFields = {
    latitude:Number(objFromDb.latitude),
    longitude:Number(objFromDb.longitude),
    id:Number(objFromDb.composition_id),
    context_id:Number(objFromDb.context_id),
    tags:objFromDb.tags.map((tag)=>Number(tag.tag_id)),
    composition_id: Number(objFromDb.composition_id),
    user_id:Number(objFromDb.user_id),
  }
  return Object.assign({}, objFromDb, reassignFields);
}

export function transformTagsFromDb(objsFromDb)
{
  return objsFromDb.map((obj)=>{return transformTagFromDb(obj)});
}

export function transformTagFromDb(objFromDb)
{
  if(!objFromDb)
    customLog("transforming null object:");
  
  return Object.assign({}, objFromDb, {tag_id:Number(objFromDb.tag_id)});
}

export function transformContextsFromDb(objsFromDb)
{
  return objsFromDb.map((obj)=>{return transformContexFromDb(obj)});
}

export function transformContexFromDb(objFromDb)
{
  if(!objFromDb)
    customLog("transforming null object:");
  
  return Object.assign({}, objFromDb, {context_id:Number(objFromDb.context_id)});
}

export function transformUsersFromDb(objsFromDb)
{
  return objsFromDb.map((obj)=>{return transformUserFromDb(obj)});
}

export function transformUserFromDb(objFromDb)
{
  if(!objFromDb)
    customLog("transforming null object:");
  
  return Object.assign({}, objFromDb, {user_id:Number(objFromDb.user_id)});
}

export function addIncludedToComps(comps, listCompositions)
{
  return comps.map((comp)=>{return addIncludedToComp(comp, listCompositions, false)});
}

export function addIncludedToComp(comp, listCompositions, forceNewIfChanged)
{
  var included = listCompositions ? listCompositions.includes(comp.id) : false;
  
  var returnComp;

  var changed = included == comp.included;

  if(forceNewIfChanged && changed)
  {
    return Object.assign({}, comp, {included:included});
  }
  else
  {
    comp.included = included;
  }
  return comp;
}


// WEBPACK FOOTER //
// ./js/appDataTransformations.js